var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.8a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6ZM16 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    fill: "#42210A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20c.067-.35.187-.76.369-1.2.86-2.08 3.104-4.81 7.63-4.81 4.527 0 6.772 2.73 7.632 4.81.182.44.302.85.369 1.2l-7.415.006v-1.209l5.73.003c-.84-1.655-2.73-3.61-6.316-3.61-3.585 0-5.474 1.955-6.314 3.61l5.74-.001-.002 1.207L4 20Z",
    fill: "#42210A"
  })));
};
export default SvgProfile;